import React from 'react';
import TopNav from '../components/TopNav';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Clock } from 'lucide-react';

export default function Portfolio() {
  return (
    <div className="min-h-screen flex flex-col">
      <TopNav />
      
      <main className="flex-grow">
        <div className="bg-gradient-to-b from-muted/50 to-background py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <Badge className="mb-4" variant="secondary">Our Portfolio</Badge>
              <h1 className="text-5xl font-semibold tracking-tight mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Portfolio Companies
              </h1>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Building the future through automation. We create, launch, grow, partner with, and acquire companies that simplify how businesses operate.
              </p>
            </div>
            
            <Card className="rounded-xl bg-gradient-to-br from-primary/5 to-background border-2 max-w-2xl mx-auto" style={{ borderColor: 'var(--ap-blue)' }}>
              <CardContent className="pt-12 pb-12 text-center">
                <Clock className="h-16 w-16 mx-auto mb-6" style={{ color: 'var(--ap-blue)' }} />
                <h2 className="text-3xl font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  Launching Soon
                </h2>
                <p className="text-lg text-muted-foreground max-w-xl mx-auto mb-6">
                  We currently have 12 businesses either in the build process or being transitioned over to our automation models.
                </p>
                <p className="text-muted-foreground mb-6">
                  These will periodically be launched and showcased here as they come online.
                </p>
                <div className="border-t pt-6 mt-6">
                  <p className="text-sm text-muted-foreground max-w-lg mx-auto mb-4">
                    Only select businesses of ours will be displayed on this page, due to confidentiality agreements or for strategic reasons.
                  </p>
                  <p className="text-sm font-medium">
                    Happy to sign an NDA and get into the details with potential investors, operators, or partners.
                  </p>
                </div>
              </CardContent>
            </Card>
            
            <div className="mt-12 text-center">
              <Card className="rounded-xl bg-muted/30 inline-block">
                <CardContent className="pt-6 px-8">
                  <p className="text-sm text-muted-foreground">
                    Interested in partnering? <a href="/investment-opportunities" className="font-semibold hover:underline" style={{ color: 'var(--ap-blue)' }}>Learn about Investment Opportunities</a>
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
